import { Image } from "@chakra-ui/react";
import spinner from "../assets/loading.gif";

export default function CustomSpinner({ size }) {
  return (
    // <Spinner />
    <Image src={spinner} w={size = 'sm' ? '5vh' : '100px'} />
  );
}
